// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ActivityHistoryViewLoadEvent
 */
export var ActivityHistoryViewLoad = function (_a) {
    var loadTimeMs = _a.loadTimeMs, firstViewAfterLogin = _a.firstViewAfterLogin, isTreehouse = _a.isTreehouse, fetchingTimeMs = _a.fetchingTimeMs, processingTimeMs = _a.processingTimeMs, renderingTimeMs = _a.renderingTimeMs;
    return ({
        name: "ActivityHistory View Load",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "View",
            load_time_ms: loadTimeMs !== undefined && loadTimeMs !== null ? loadTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            first_view_after_login: firstViewAfterLogin !== undefined && firstViewAfterLogin !== null ? firstViewAfterLogin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            fetching_time_ms: fetchingTimeMs !== undefined && fetchingTimeMs !== null ? fetchingTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            processing_time_ms: processingTimeMs !== undefined && processingTimeMs !== null ? processingTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rendering_time_ms: renderingTimeMs !== undefined && renderingTimeMs !== null ? renderingTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryViewItemEvent
 */
export var ActivityHistoryViewItem = function (_a) {
    var entityId = _a.entityId, isOutstanding = _a.isOutstanding, isBadged = _a.isBadged, paymentRole = _a.paymentRole, paymentOrientation = _a.paymentOrientation, paymentState = _a.paymentState, origin = _a.origin, isTreehouse = _a.isTreehouse, activityFlowToken = _a.activityFlowToken, searchFlowToken = _a.searchFlowToken, queryToken = _a.queryToken, activityItemType = _a.activityItemType, counterpartyToken = _a.counterpartyToken, rowIndex = _a.rowIndex, isRecurring = _a.isRecurring;
    return ({
        name: "ActivityHistory View Item",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "View",
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_outstanding: isOutstanding !== undefined && isOutstanding !== null ? isOutstanding.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_badged: isBadged !== undefined && isBadged !== null ? isBadged.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_role: paymentRole !== undefined && paymentRole !== null ? paymentRole.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_orientation: paymentOrientation !== undefined && paymentOrientation !== null ? paymentOrientation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_state: paymentState !== undefined && paymentState !== null ? paymentState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_flow_token: searchFlowToken !== undefined && searchFlowToken !== null ? searchFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            query_token: queryToken !== undefined && queryToken !== null ? queryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_item_type: activityItemType !== undefined && activityItemType !== null ? activityItemType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            counterparty_token: counterpartyToken !== undefined && counterpartyToken !== null ? counterpartyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row_index: rowIndex !== undefined && rowIndex !== null ? rowIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_recurring: isRecurring !== undefined && isRecurring !== null ? isRecurring.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySearchStartEvent
 */
export var ActivityHistorySearchStart = function (_a) {
    var isTreehouse = _a.isTreehouse, activityFlowToken = _a.activityFlowToken, searchFlowToken = _a.searchFlowToken;
    return ({
        name: "ActivityHistory Search Start",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Search",
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_flow_token: searchFlowToken !== undefined && searchFlowToken !== null ? searchFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryFilterStartEvent
 */
export var ActivityHistoryFilterStart = function () { return ({
    name: "ActivityHistory Filter Start",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Filter",
    }
}); };
/**
 * @see ActivityHistoryFilterSubmitEvent
 */
export var ActivityHistoryFilterSubmit = function (_a) {
    var dateStart = _a.dateStart, dateEnd = _a.dateEnd, datePreset = _a.datePreset, amountMin = _a.amountMin, amountMax = _a.amountMax, currency = _a.currency, moneyMovement = _a.moneyMovement, itemType = _a.itemType;
    return ({
        name: "ActivityHistory Filter Submit",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Filter",
            date_start: dateStart !== undefined && dateStart !== null ? dateStart.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            date_end: dateEnd !== undefined && dateEnd !== null ? dateEnd.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            date_preset: datePreset !== undefined && datePreset !== null ? datePreset.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_min: amountMin !== undefined && amountMin !== null ? amountMin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_max: amountMax !== undefined && amountMax !== null ? amountMax.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency: currency !== undefined && currency !== null ? currency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            money_movement: moneyMovement !== undefined && moneyMovement !== null ? moneyMovement.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            item_type: itemType !== undefined && itemType !== null ? itemType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryFilterClearEvent
 */
export var ActivityHistoryFilterClear = function () { return ({
    name: "ActivityHistory Filter Clear",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Filter",
    }
}); };
/**
 * @see ActivityHistoryFilterCloseEvent
 */
export var ActivityHistoryFilterClose = function () { return ({
    name: "ActivityHistory Filter Close",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Filter",
    }
}); };
/**
 * @see ActivityHistorySelectInviteFriendsEvent
 */
export var ActivityHistorySelectInviteFriends = function () { return ({
    name: "ActivityHistory Select InviteFriends",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Select",
    }
}); };
/**
 * @see ActivityHistorySelectViewPickerEvent
 */
export var ActivityHistorySelectViewPicker = function (_a) {
    var blockerId = _a.blockerId, blockerType = _a.blockerType, clientScenario = _a.clientScenario, count = _a.count, flowToken = _a.flowToken, includeTokenRegex = _a.includeTokenRegex, isTreehouse = _a.isTreehouse;
    return ({
        name: "ActivityHistory Select ViewPicker",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Select",
            blocker_id: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocker_type: blockerType !== undefined && blockerType !== null ? blockerType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            include_token_regex: includeTokenRegex !== undefined && includeTokenRegex !== null ? includeTokenRegex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySelectSubmitRecordEvent
 */
export var ActivityHistorySelectSubmitRecord = function (_a) {
    var blockerId = _a.blockerId, blockerType = _a.blockerType, clientScenario = _a.clientScenario, entityToken = _a.entityToken, flowToken = _a.flowToken, index = _a.index;
    return ({
        name: "ActivityHistory Select SubmitRecord",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Select",
            blocker_id: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocker_type: blockerType !== undefined && blockerType !== null ? blockerType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_token: entityToken !== undefined && entityToken !== null ? entityToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySelectQABItemEvent
 */
export var ActivityHistorySelectQABItem = function (_a) {
    var itemType = _a.itemType, origin = _a.origin, isTreehouse = _a.isTreehouse, activityFlowToken = _a.activityFlowToken, counterpartyToken = _a.counterpartyToken;
    return ({
        name: "ActivityHistory Select QABItem",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Select",
            item_type: itemType !== undefined && itemType !== null ? itemType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            counterparty_token: counterpartyToken !== undefined && counterpartyToken !== null ? counterpartyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySelectOpenWithFilterEvent
 *
 * @deprecated This event is obsolete. Use `OpenWithFilterOrSort` instead.
 */
export var ActivityHistorySelectOpenWithFilter = function (_a) {
    var selectedFilterCount = _a.selectedFilterCount;
    return ({
        name: "ActivityHistory Select OpenWithFilter",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Select",
            selected_filter_count: selectedFilterCount !== undefined && selectedFilterCount !== null ? selectedFilterCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySelectOpenWithFilterOrSortEvent
 */
export var ActivityHistorySelectOpenWithFilterOrSort = function (_a) {
    var selectedFilterCount = _a.selectedFilterCount, isSortApplied = _a.isSortApplied, isEnriched = _a.isEnriched;
    return ({
        name: "ActivityHistory Select OpenWithFilterOrSort",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Select",
            selected_filter_count: selectedFilterCount !== undefined && selectedFilterCount !== null ? selectedFilterCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_sort_applied: isSortApplied !== undefined && isSortApplied !== null ? isSortApplied.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_enriched: isEnriched !== undefined && isEnriched !== null ? isEnriched.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySortStartEvent
 */
export var ActivityHistorySortStart = function () { return ({
    name: "ActivityHistory Sort Start",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Sort",
    }
}); };
/**
 * @see ActivityHistorySortSubmitEvent
 */
export var ActivityHistorySortSubmit = function (_a) {
    var sortBy = _a.sortBy;
    return ({
        name: "ActivityHistory Sort Submit",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Sort",
            sort_by: sortBy !== undefined && sortBy !== null ? sortBy.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistorySortCloseEvent
 */
export var ActivityHistorySortClose = function () { return ({
    name: "ActivityHistory Sort Close",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Sort",
    }
}); };
/**
 * @see ActivityHistoryRefreshForceEvent
 */
export var ActivityHistoryRefreshForce = function (_a) {
    var isTreehouse = _a.isTreehouse, activityFlowToken = _a.activityFlowToken;
    return ({
        name: "ActivityHistory Refresh Force",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Refresh",
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryDownloadStartEvent
 */
export var ActivityHistoryDownloadStart = function (_a) {
    var hasFilter = _a.hasFilter, isDynamic = _a.isDynamic, hasSort = _a.hasSort, hasTextSearch = _a.hasTextSearch;
    return ({
        name: "ActivityHistory Download Start",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Download",
            has_filter: hasFilter !== undefined && hasFilter !== null ? hasFilter.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_dynamic: isDynamic !== undefined && isDynamic !== null ? isDynamic.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_sort: hasSort !== undefined && hasSort !== null ? hasSort.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_text_search: hasTextSearch !== undefined && hasTextSearch !== null ? hasTextSearch.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryDownloadSuccessEvent
 */
export var ActivityHistoryDownloadSuccess = function () { return ({
    name: "ActivityHistory Download Success",
    parameters: {
        cdf_entity: "ActivityHistory",
        cdf_action: "Download",
    }
}); };
/**
 * @see ActivityHistoryDownloadFailureEvent
 */
export var ActivityHistoryDownloadFailure = function (_a) {
    var reason = _a.reason;
    return ({
        name: "ActivityHistory Download Failure",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Download",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryTapItemEvent
 */
export var ActivityHistoryTapItem = function (_a) {
    var entityId = _a.entityId, isOutstanding = _a.isOutstanding, isBadged = _a.isBadged, paymentRole = _a.paymentRole, paymentOrientation = _a.paymentOrientation, paymentState = _a.paymentState, origin = _a.origin, isTreehouse = _a.isTreehouse, activityFlowToken = _a.activityFlowToken, searchFlowToken = _a.searchFlowToken, queryToken = _a.queryToken, activityItemType = _a.activityItemType, counterpartyToken = _a.counterpartyToken, rowIndex = _a.rowIndex, tapElement = _a.tapElement;
    return ({
        name: "ActivityHistory Tap Item",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Tap",
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_outstanding: isOutstanding !== undefined && isOutstanding !== null ? isOutstanding.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_badged: isBadged !== undefined && isBadged !== null ? isBadged.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_role: paymentRole !== undefined && paymentRole !== null ? paymentRole.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_orientation: paymentOrientation !== undefined && paymentOrientation !== null ? paymentOrientation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_state: paymentState !== undefined && paymentState !== null ? paymentState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_treehouse: isTreehouse !== undefined && isTreehouse !== null ? isTreehouse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_flow_token: searchFlowToken !== undefined && searchFlowToken !== null ? searchFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            query_token: queryToken !== undefined && queryToken !== null ? queryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_item_type: activityItemType !== undefined && activityItemType !== null ? activityItemType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            counterparty_token: counterpartyToken !== undefined && counterpartyToken !== null ? counterpartyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row_index: rowIndex !== undefined && rowIndex !== null ? rowIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            tap_element: tapElement !== undefined && tapElement !== null ? tapElement.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ActivityHistoryBrowseViewScreenEvent
 */
export var ActivityHistoryBrowseViewScreen = function (_a) {
    var activityFlowToken = _a.activityFlowToken, viewLoadTimeMs = _a.viewLoadTimeMs;
    return ({
        name: "ActivityHistory Browse ViewScreen",
        parameters: {
            cdf_entity: "ActivityHistory",
            cdf_action: "Browse",
            activity_flow_token: activityFlowToken !== undefined && activityFlowToken !== null ? activityFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_load_time_ms: viewLoadTimeMs !== undefined && viewLoadTimeMs !== null ? viewLoadTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
